import { useTranslation } from "react-i18next";
import BlurRevealText from "./BlurRevealText";
import { useBookDemo } from "../context/BookDemoContext";

function ComparisonArrowIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" aria-hidden="true">
      <path
        d="M10.4688 4.375L16.0938 10L10.4688 15.625M15.3125 10H3.90625"
        stroke="currentColor"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ComparisonTable() {
  const { t } = useTranslation();
  const { openBookDemo } = useBookDemo();
  const comparisonRows = t("comparison.rows", { returnObjects: true });

  return (
    <section className="comparison-section py-50">
      <div className="container">
        <BlurRevealText
          as="h2"
          className="comparison-title"
          lines={[t("comparison.title")]}
        />

        <div className="comparison-table-wrap">
          <table className="comparison-table">
            <thead>
              <tr>
                <th scope="col">
                  <span className="visually-hidden">
                    {t("comparison.criteria")}
                  </span>
                </th>
                <th scope="col">{t("comparison.colInHouse")}</th>
                <th scope="col" className="comparison-col-highlight">
                  {t("comparison.colR4l")}
                </th>
                <th scope="col">{t("comparison.colReseller")}</th>
              </tr>
            </thead>
            <tbody>
              {comparisonRows.map((row) => (
                <tr key={row.label}>
                  <th scope="row">{row.label}</th>
                  <td>{row.inHouse}</td>
                  <td className="comparison-col-highlight">{row.r4l}</td>
                  <td>{row.reseller}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <button
          className="platform-capabilities-link comparison-link"
          type="button"
          onClick={openBookDemo}
        >
          {t("nav.bookDemo")}
          <ComparisonArrowIcon />
        </button>
      </div>
    </section>
  );
}

export default ComparisonTable;
